import { validateStatus } from "../module/constants/DataSource.constants.js";
const DataSourceListUserContextParam = {
  showStatus: {
    paramType: "enum",
    validEnumValues: [validateStatus.ValidateSuccess, validateStatus.ValidateFailed, validateStatus.Unknown],
    storeParamName: "showStatus",
    defaultValue: [validateStatus.ValidateSuccess, validateStatus.ValidateFailed, validateStatus.Unknown],
    isMultiValue: true
  },
  filter: { paramType: "string" },
  search: { paramType: "string" },
  filterOrSearch: { paramType: "string" },
  showAdditionalProps: { paramType: "string" }
};
export {
  DataSourceListUserContextParam
};
//# sourceMappingURL=DataSourceListUserContextParams.js.map
